import { EventType, SourcePages, Features } from 'lib/EventSchema';
import { EventData } from 'lib/EventLogger/Event';
import { VehicleEventInfo } from '../../types';

export type Directions = 'fwd' | 'bk';

interface ScrollEventInfo extends VehicleEventInfo {
  direction: Directions;
  feature: Features;
}

function event({ direction, feature, trackingParams }: ScrollEventInfo): EventData {
  return {
    event_type: EventType.engagement,
    source_page: SourcePages.Vdp,
    feature,
    engagement_type: `scroll_${direction}`,
    event_context: {
      tracking_params: trackingParams,
    },
  };
}

export default event;
